// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"152":"7a7b156d","453":"468233b9","455":"c609e39c","868":"4de14ee1","977":"95e55237"}[chunkId] + ".chunk.js";
};